import React, { createContext, useContext, useState, useCallback } from 'react';

interface LayoutActionsContextType {
  actions: React.ReactNode | null;
  setActions: (node: React.ReactNode | null) => void;
}

const LayoutActionsContext = createContext<LayoutActionsContextType>({
  actions: null,
  setActions: () => {},
});

export const LayoutActionsProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [actions, setActionsState] = useState<React.ReactNode | null>(null);
  const setActions = useCallback((node: React.ReactNode | null) => setActionsState(node), []);

  return (
    <LayoutActionsContext.Provider value={{ actions, setActions }}>
      {children}
    </LayoutActionsContext.Provider>
  );
};

export const useLayoutActions = () => useContext(LayoutActionsContext);
